export const BaseEnvironment = {
  RedirectUrlKey: 'REDIRECT_URL_KEY',
} as const

export type BaseEnvironment = typeof BaseEnvironment

export const EnvironmentFromFile = {
  Adobe: 'ADOBE_DTM',
  LegacyAuthKey: 'IDS_AUTH_KEY',
  AuthKey: 'AUTH0_AUTH_KEY',
  ProfileServiceUrl: 'PROFILE_SERVICE_URL',
  StaticAssetsUrl: 'STATIC_ASSETS_URL',
  OrderServiceUrl: 'ORDER_SERVICE_URL',
  CinchcareServiceUrl: 'CINCHCARE_SERVICE_URL',
  DeliveryServiceURl: 'DELIVERY_SERVICE_URL',
  SearchServiceUrl: 'SEARCH_SERVICE_URL',
  SearchChannelId: 'SEARCH_CHANNEL_ID',
  SettlementServiceUrl: 'SETTLEMENT_SERVICE_URL',
  PermissionsUrl: 'PERMISSION_URL',
  SegmentKey: 'SEGMENT_KEY',
  IdentityServiceUrl: 'IDENTITY_SERVICE_URL',
  Auth0ServiceUrl: 'AUTH0_SERVICE_URL',
  Auth0DatabaseName: 'AUTH0_DATABASE_NAME',
  Auth0ClientId: 'AUTH0_CLIENT_ID',
  promoBannerName: 'PROMO_BANNER_NAME',
  cinchUrl: 'CINCH_URL',
  cinchAppUrl: 'CINCH_APP_URL',
  TrustpilotUrl: 'TRUSTPILOT_URL',
  StoryblokBFFComponent: 'STORYBLOK_BFF_COMPONENT',
  consumerValuationsServiceUrl: 'CONSUMER_VALUATIONS_SERVICE_URL',
  CinchChargeCardRequestUrl: 'CINCH_CHARGE_CARD_REQUEST_URL',
  CinchChargeCardRequestAPIKey: 'CINCH_CHARGE_CARD_REQUEST_API_KEY',
  ProductDetailServiceUrl: 'PRODUCT_DETAIL_SERVICE_URL',
  ReservationStatusUrl: 'RESERVATION_STATUS_URL',
  InventoryServiceHistoryUrl: 'INVENTORY_SERVICE_HISTORY_URL',
  IOSAppStoreUrl: 'IOS_APP_STORE_URL',
  AndroidAppStoreUrl: 'ANDROID_APP_STORE_URL',
  AdminFeeReturnToCheckout: 'ADMIN_FEE_RETURN_TO_CHECKOUT',
  AdminFeeValue: 'ADMIN_FEE_VALUE',
  AdminFeeLoyalty: 'ADMIN_FEE_LOYALTY',
  CheckoutReservationsDecoupling: 'CHECKOUT_RESERVATIONS_DECOUPLING',
  CheckoutReservationsDecouplingPhaseTwo:
    'CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO',
  ReservationServiceUrl: 'RESERVATION_SERVICE_URL',
  DeliverySlotAvailabilityServiceUrl: 'DELIVERY_SLOT_AVAILABILITY_SERVICE_URL',
  LogisticsFeesServiceUrl: 'LOGISTICS_FEES_SERVICE_URL',
  LogisticsRoutingServiceUrl: 'LOGISTICS_ROUTING_SERVICE_URL',
  FinanceApplicationServiceUrl: 'FINANCE_APPLICATION_SERVICE_URL',
  FinanceServiceUrl: 'FINANCE_SERVICE_URL',
  FinanceQuoteServiceUrl: 'FINANCE_QUOTE_SERVICE_URL',
  FinanceSoftSearchUrlPath: 'FINANCE_SOFT_SEARCH_URL_PATH',
  PaymentLinkServiceUrl: 'PAYMENT_LINK_SERVICE_URL',
  StripePublishableKey: 'STRIPE_PUBLISHABLE_KEY',
  GapServiceUrl: 'GAP_SERVICE_URL',
  ServicingAndWarrantyFlag: 'SERVICING_AND_WARRANTY_FLAG',
  DisableCinchCare: 'DISABLE_CINCHCARE',
  GapInsuranceFlag: 'GAP_INSURANCE_FLAG',
  CustomerDataAPIKey: 'CUSTOMER_DATA_API_KEY',
  CustomerDataAPIUrl: 'CUSTOMER_DATA_API_URL',
  SearchMultipleImages: 'SEARCH_MULTIPLE_IMAGES',
  EnabledZendeskScript: 'ENABLE_ZENDESK_SCRIPT',
  VehicleCardV2: 'VEHICLE_CARD_V2',
  NextBestAction: 'NEXT_BEST_ACTION',
  VehicleOwnershipServiceUrl: 'VEHICLE_OWNERSHIP_SERVICE_URL',
  enableBuyNowMessaging: 'ENABLE_BUY_NOW_CTA_MESSAGING',
  EnableEmailQuote: 'ENABLE_EMAIL_QUOTE',
  EnableFavouritingHomePageChanges: 'HOMEPAGE_FAVOURITING',
  EnableProductDetailPageVariant: 'ENABLE_PRODUCT_DETAIL_PAGE_VARIANT',
  EnableQuotesMarketing: 'ENABLE_QUOTES_MARKETING',
  SearchFinanceTypeFilter: 'SEARCH_FINANCE_TYPE_FILTER',
  ShowQuoteTermMonths: 'SHOW_QUOTE_TERM_MONTHS',
  ShowScorelessTrustpilot: 'SHOW_SCORELESS_TRUSTPILOT',
  SoftSearchChanges: 'SOFT_SEARCH_CHANGES',
  PDPSoftSearch: 'PDP_SOFT_SEARCH',
  showCinchCoverInProfile: 'SHOW_CINCH_COVER_IN_PROFILE',
  showMultiTermVAPsInProfile: 'SHOW_MULTI_TERM_VAPS_IN_PROFILE',
  showTyreInsurance: 'SHOW_TYRE_INSURANCE_IN_PROFILE',
  showGAPInsuranceInProfile: 'SHOW_GAP_INSURANCE_IN_PROFILE',
  showSelfServiceRenewalsV3: 'SHOW_SELF_SERVICE_RENEWALS_V3',
  bankServiceUrl: 'BANK_SERVICE_URL',
  VapServiceUrl: 'VAP_SERVICE_URL',
  UseRefreshToken: 'USE_REFRESH_TOKEN',
  ShowHelpAndSupportChanges: 'SHOW_HELP_AND_SUPPORT_CHANGES',
  HelpAndSupportUrl: 'HELP_AND_SUPPORT_URL',
  SearchFinanceCalculatorCTA: 'SEARCH_FINANCE_CALCULATOR_CTA',
  EnableSegmentTrackingInUsedCars: 'ENABLE_SEGMENT_TRACKING_IN_USED_CARS',
  SearchDataDrivenSortOrder: 'SEARCH_DATA_DRIVEN_SORT_ORDER',
  NavbarValuationExperimentId: 'NAVBAR_VALUATION_EXPERIMENT_ID',
  StoreAvailabilityUrl: 'STORE_AVAILABILITY_URL',
  StoreAvailabilityKey: 'STORE_AVAILABILITY_KEY',
  GoogleMapsApiKey: 'GOOGLE_GEOCODING_API_KEY',
  GoogleMapsBaseUrl: 'GOOGLE_MAPS_BASE_URL',
  SearchFinanceCalculatorCTAExperimentId:
    'SEARCH_FINANCE_CALCULATOR_CTA_EXPERIMENT_ID',
  VehiclePurchaseBaseUrl: 'VEHICLE_PURCHASE_BASE_URL',
  SearchDataDrivenSortExperimentId: 'SEARCH_DATA_DRIVEN_SORT_EXPERIMENT_ID',
  EnableSellMyCar: 'ENABLE_SELL_MY_CAR',
  EnableNewProfileHeader: 'ENABLE_NEW_PROFILE_HEADER',
  GetAddressIoUrl: 'GET_ADDRESS_IO_URL',
  GetAddressIoApiKey: 'GET_ADDRESS_IO_API_KEY',
  FinanceApplicationCheckOutBanner: 'FINANCE_APPLICATION_CHECKOUT_BANNER',
  CarFinanceShowTrustPilot: 'CAR_FINANCE_SHOW_TRUST_PILOT',
  SearchFreeCollectionLabels: 'SEARCH_FREE_COLLECTION_LABELS',
  SearchFreeCollectionLabelsExperimentId:
    'SEARCH_FREE_COLLECTION_LABELS_EXPERIMENT_ID',
  SitesUrl: 'SITES_URL',
  SitesApiKey: 'SITES_API_KEY',
  EnableNewCars: 'ENABLE_NEW_CARS',
  EnableNewCarsFinance: 'ENABLE_NEW_CARS_FINANCE',
  EnableNewCarsSEO: 'ENABLE_NEW_CARS_SEO',
  EnableVAPSFeatureCarMaintenance: 'ENABLE_VAPS_FEATURE_CAR_MAINTENANCE',
  EnableMarshallCollectionTrial: 'ENABLE_MARSHALL_COLLECTION_TRIAL',
  CarOverviewAccordionsExperimentId: 'CAR_OVERVIEW_ACCORDIONS_EXPERIMENT_ID',
  LeadGenServiceUrl: 'LEAD_GEN_SERVICE_URL',
  FinOfferCommission: 'FIN_OFFER_COMMISSION',
  FinanceSDDPdf: 'FINANCE_SDD_PDF',
  EvolutionIddUrl: 'EVOLUTION_IDD_URL',
  FinanceCommissionPdf: 'FINANCE_COMMISSION_PDF',
  SearchNewCars: 'SEARCH_NEW_CARS',
  NewCarsApiUrl: 'NEW_CARS_API_URL',
  FinanceSoftSearchV2: 'FINANCE_SOFT_SEARCH_V2',
  FinanceSoftSearchUrlV2: 'FINANCE_SOFT_SEARCH_URL_V2',
  EnableCompareButton: 'ENABLE_COMPARE_BUTTON',
  FinanceApplicationAddressHistorySubBuilding:
    'FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING',
  CinchServicingUrl: 'CINCH_SERVICING_URL',
  NewCarsFiltersFlag: 'NEW_CARS_FILTERS_FLAG',
  proposalSubmissionURL: 'PROPOSAL_SUBMISSION_URL',
  proposalSubmissionAPIKey: 'PROPOSAL_SUBMISSION_API_KEY',
  EnableServiceBooking: 'ENABLE_SERVICE_BOOKING',
} as const

export type EnvironmentFromFile = typeof EnvironmentFromFile

export const EnvironmentFromProcess = {
  DataDogAPIKey: 'DATADOG_API_KEY',
  DataDogClientId: 'DATADOG_CLIENT_ID',
  DataDogRumApplicationId: 'DATADOG_RUM_APPLICATION_ID',
  DataDogRumClientToken: 'DATADOG_RUM_CLIENT_TOKEN',
  DataDogRumGlobalSampleRate: 'DATADOG_RUM_GLOBAL_SAMPLE_RATE',
  DataDogRumGlobalReplaySampleRate: 'DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE',
  DataDogServiceName: 'DATADOG_SERVICE_NAME',
  BuildId: 'BUILD_ID',
} as const

export type EnvironmentFromProcess = typeof EnvironmentFromProcess

export type IBaseEnvironment = Record<
  BaseEnvironment[keyof BaseEnvironment],
  string | undefined
> & {
  REDIRECT_URL_KEY: string
}

export type IEnvironmentFromFile = Record<
  EnvironmentFromFile[keyof EnvironmentFromFile],
  string | undefined
> & {
  ADOBE_DTM: string
  IDS_AUTH_KEY: string
  AUTH0_AUTH_KEY: string
  CINCHCARE_SERVICE_URL: string
  PERMISSION_URL: string
  DELIVERY_SERVICE_URL: string
  ORDER_SERVICE_URL: string
  PROFILE_SERVICE_URL: string
  SEARCH_SERVICE_URL: string
  SEARCH_CHANNEL_ID: string
  SETTLEMENT_SERVICE_URL: string
  SEGMENT_KEY: string
  STATIC_ASSETS_URL: string
  IDENTITY_SERVICE_URL: string
  AUTH0_SERVICE_URL: string
  AUTH0_DATABASE_NAME: string
  AUTH0_CLIENT_ID: string
  PROMO_BANNER_NAME: string
  CINCH_URL: string
  TRUSTPILOT_URL: string
  CONSUMER_VALUATIONS_SERVICE_URL: string
  CINCH_CHARGE_CARD_REQUEST_URL: string
  CINCH_CHARGE_CARD_REQUEST_API_KEY: string
  PRODUCT_DETAIL_SERVICE_URL: string
  RESERVATION_STATUS_URL: string
  INVENTORY_SERVICE_HISTORY_URL: string
  IOS_APP_STORE_URL: string
  ANDROID_APP_STORE_URL: string
  ADMIN_FEE_RETURN_TO_CHECKOUT: string
  ADMIN_FEE_VALUE: string
  UNSUBSCRIBE_SERVICE_URL: string
  UNSUBSCRIBE_MINIMUM_DURATION: string
  CHECKOUT_RESERVATIONS_DECOUPLING: string
  CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: string
  RESERVATION_SERVICE_URL: string
  DELIVERY_SLOT_AVAILABILITY_SERVICE_URL: string
  LOGISTICS_FEES_SERVICE_URL: string
  LOGISTICS_ROUTING_SERVICE_URL: string
  FINANCE_APPLICATION_SERVICE_URL: string
  FINANCE_SERVICE_URL: string
  FINANCE_QUOTE_SERVICE_URL: string
  PAYMENT_LINK_SERVICE_URL: string
  STRIPE_PUBLISHABLE_KEY: string
  GAP_SERVICE_URL: string
  SERVICING_AND_WARRANTY_FLAG: string
  DISABLE_CINCHCARE: string
  GAP_INSURANCE_FLAG: string
  VEHICLE_CARD_V2: string
  VEHICLE_OWNERSHIP_SERVICE_URL: string
  ENABLE_EMAIL_QUOTE: string
  HOMEPAGE_FAVOURITING: string
  SHOW_QUOTE_TERM_MONTHS: string
  HELP_AND_SUPPORT_URL: string
  NAVBAR_VALUATION_EXPERIMENT_ID: string
  ENABLE_NEW_PROFILE_HEADER: string
  GET_ADDRESS_IO_URL: string
  GET_ADDRESS_IO_API_KEY: string
  FINANCE_APPLICATION_CHECKOUT_BANNER: string
  SITES_URL: string
  SITES_API_KEY: string
  ENABLE_VAPS_FEATURE_CAR_MAINTENANCE: string
  ENABLE_MARSHALL_COLLECTION_TRIAL: string
  LEAD_GEN_SERVICE_URL: string
  FIN_OFFER_COMMISSION: string
  EVOLUTION_IDD_URL: string
  FINANCE_SDD_PDF: string
  FINANCE_COMMISSION_PDF: string
  NEW_CARS_API_URL: string
  FINANCE_SOFT_SEARCH_V2: string
  FINANCE_SOFT_SEARCH_URL_V2: string
  FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING: string
  PROPOSAL_SUBMISSION_URL: string
  PROPOSAL_SUBMISSION_API_KEY: string
  ENABLE_SERVICE_BOOKING: string
}

export type IEnvironmentFromProcess = Record<
  EnvironmentFromProcess[keyof EnvironmentFromProcess],
  string | undefined
> & {
  BUILD_ID: string | undefined
  DATADOG_API_KEY: string | undefined
  DATADOG_CLIENT_ID: string | undefined
  DATADOG_RUM_APPLICATION_ID: string | undefined
  DATADOG_RUM_CLIENT_TOKEN: string | undefined
  DATADOG_RUM_GLOBAL_SAMPLE_RATE: string | undefined
  DATADOG_SERVICE_NAME: string | undefined
  DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE: string | undefined
}

export interface IEnvironment
  extends IBaseEnvironment,
    IEnvironmentFromFile,
    IEnvironmentFromProcess {}

export const Env = {
  ...BaseEnvironment,
  ...EnvironmentFromFile,
  ...EnvironmentFromProcess,
}

export type Env = BaseEnvironment & EnvironmentFromFile & EnvironmentFromProcess

export type keys = keyof IEnvironment
